<template>
  <div>
    <select-date-header></select-date-header>
    <select-date-title-lea-abs
      :activeTab="activeTab"
    ></select-date-title-lea-abs>
    <select-date-content-appl
      @selectDate="selectDate"
      ref="dateContent"
    ></select-date-content-appl>
  </div>
</template>
<script>
import SelectDateHeader from '@/components/application/form/SelectDateHeader.vue';
import SelectDateContentAppl from '@/components/application/form/SelectDateContentAppl.vue';
import SelectDateTitleLeaAbs from '@/components/application/form/SelectDateTitleLeaAbs.vue';

import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';

import { mapGetters, mapMutations } from 'vuex';
import applCode from '@/const/applCodeConstants';

export default {
  mixins: [applCdMixin],
  components: {
    SelectDateHeader,
    SelectDateContentAppl,
    SelectDateTitleLeaAbs,
  },
  data: () => ({
    activeTab: 'E',
  }),
  computed: {
    ...mapGetters('ELA', [
      'GET_S_YMD',
      'GET_E_YMD',
      'GET_REQUEST_HOUR',
      'GET_REWARD_LIST',
      'GET_APPL_CD1',
    ]),
    ...mapGetters(['GET_APPL_CD', 'GET_LIMIT_TERM', 'GET_CA_DAYS', 'GET_PER_DAY', 'GET_REMAIN_DAYS_BEFORE',]),
  },
  methods: {
    ...mapMutations('ELA', [
      'SET_S_YMD',
      'SET_E_YMD',
      'SET_REWARD_LIST',
      'SET_REQ_TIME',
    ]),

    async selectDate() {
      if (
        this.GET_S_YMD.replaceAll('-', '') > this.GET_E_YMD.replaceAll('-', '')
      ) {
        alert('종료일이 시작일보다 클 수 없습니다');
        this.SET_E_YMD('');
        this.$refs.dateContent.dates[0] = '';
        this.$refs.dateContent.dates[1] = '';
        this.OFF_APP_SPINNER();
        return;
      }

      if (this.GET_APPL_CD1 === applCode.LeaAbsAdd) {

        let usedayCount = this.getDaysBetween(this.GET_S_YMD.replaceAll('-', ''), this.GET_E_YMD.replaceAll('-', ''));

        if (parseInt(this.GET_REMAIN_DAYS_BEFORE) < parseInt(usedayCount)) {
          alert('신청가능일을 초과 하였습니다');
          this.$refs.dateContent.dates[0] = '';
          this.$refs.dateContent.dates[1] = '';
          this.OFF_APP_SPINNER();
          return;
        }

        this.$router.push(routerNames.LeaAbsAppParLeaveAddView);
      } else if (
        this.GET_APPL_CD === applCode.LeaAbsParental ||
        this.GET_APPL_CD === applCode.LeaAbsFamily ||
        this.GET_APPL_CD === applCode.LeaAbsInfertility ||
        this.GET_APPL_CD === applCode.LeaAbsSick ||
        this.GET_APPL_CD === applCode.LeaAbsCasualty ||
        this.GET_APPL_CD === applCode.LeaAbsNew ||
        this.GET_APPL_CD === applCode.eaAbsExtension
      ) {

        const oldDate = new Date(this.GET_S_YMD);
        const newDate = new Date(this.GET_E_YMD);
        let diff = Math.abs(newDate.getTime() - oldDate.getTime());
        diff = Math.ceil(diff / (1000 * 60 * 60 * 24));

        let period = diff + this.GET_CA_DAYS===''?0:this.GET_CA_DAYS + 1;

        //let usedayCount = diff + 1;
        let usedayCount = this.getDaysBetween(this.GET_S_YMD.replaceAll('-', ''), this.GET_E_YMD.replaceAll('-', ''));

        if (parseInt(this.GET_REMAIN_DAYS_BEFORE) < (parseInt(this.GET_PER_DAY) + parseInt(usedayCount)) && this.GET_APPL_CD === applCode.LeaAbsParental) {
          alert('신청가능일을 초과 하였습니다');
          this.$refs.dateContent.dates[0] = '';
          this.$refs.dateContent.dates[1] = '';
          this.OFF_APP_SPINNER();
          return;
        } else {

          //20260818 이유진 육아휴직 법 개정으로 인하여 주석처리(이용희P)
          /*
           if( usedayCount < 30 && this.GET_APPL_CD === applCode.LeaAbsParental){
						alert("* 육아휴직기간 30일 이상이어야 급여 신청 가능합니다.");
          }
          */


          if (
            this.GET_APPL_CD === applCode.LeaAbsParental ||
            this.GET_APPL_CD === applCode.LeaAbsFamily
          ) {
            this.$router.push(routerNames.LeaAbsAppStep3);
          } else if (
            this.GET_APPL_CD === applCode.LeaAbsInfertility ||
            this.GET_APPL_CD === applCode.LeaAbsSick ||
            this.GET_APPL_CD === applCode.LeaAbsCasualty ||
            this.GET_APPL_CD === applCode.LeaAbsNew ||
            this.GET_APPL_CD === applCode.eaAbsExtension
          ) {
            this.$router.push(routerNames.LeaAbsAppEtcView);
          } else {
            this.OFF_APP_SPINNER();
          }
        }
      }
    },

    getDaysBetween(startDt, endDt) {
      if (startDt === "" || endDt === "") {
          return "";
      }

      let sDt = new Date(startDt.substring(0, 4), startDt.substring(4, 6) - 1, startDt.substring(6, 8));
      let eDt = new Date(endDt.substring(0, 4), endDt.substring(4, 6) - 1, endDt.substring(6, 8));

      return Math.floor(eDt.valueOf() / (24 * 60 * 60 * 1000) - sDt.valueOf() / (24 * 60 * 60 * 1000) + 1);

    },
  },
  mounted() {
    if (!this.GET_S_YMD) {
      alert('시작일자를 선택해주세요');
      window.history.go(-1);
    }

    this.$store.commit('SET_PARAMS', []);
    this.$store.commit('SET_FILE_SEQ', '');
  },
  destroyed() {
    this.OFF_APP_SPINNER(); // 스피너 OFF
  },
};
</script>
<style></style>
